<template>
  <div class="section section--discount">
    <div class="container mb-5">
      <h3 class="title is-4 has-text-grey mb-1">{{ $t('discount.header') }}</h3>
    </div>
    <form @submit.prevent.stop="validateDiscount()">
      <div class="columns is-multiline">
        <div class="column is-one-third-tablet">
          <div class="field has-addons">
            <div class="control is-expanded">
              <label class="label is-uppercase ml-2 mb-0">{{ $t('discount.inputLabels.discountCode') }}</label>
              <b-input v-model="discountCode"
                       type="text"
                       maxlength="30"
                       :has-counter="false"
                       :disabled="isLoading"
                       :placeholder="$t('discount.inputLabels.discountCode')"/>
            </div>
            <div class="control">
              <b-button class="button is-primary-dark px-6 is-medium validate-button" native-type="submit"
                        :disabled="discountCode.length < 2"
                        :loading="isLoading">
                {{ $t('discount.actionLabels.validateCode') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <b-modal v-model="modalIsOpen" width="600px">
      <template #default="props">
        <voucher-modal/>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import VoucherModal from "./VoucherModal";
import {sendGenericErrorMessage} from "../../../utilities/send-generic-error-message";

export default {
  name: "ValidateVoucherForm",
  components: {VoucherModal},
  data() {
    return {
      discountCode: '',
      isLoading: false,
      modalIsOpen: false,
    }
  },
  methods: {
    async validateDiscount() {
      this.isLoading = true;

      await this.$store.dispatch('validateDiscountCode', {code: this.discountCode}).then(() => {
        this.modalIsOpen = true;
      }).catch((e) => {
        if (e.response.status !== 404) {
          sendGenericErrorMessage()
        } else {
          this.$buefy.dialog.alert({
            title: this.$t('discount.voucherIsNotValid'),
            message: this.$t('discount.couldNotBeValidated'),
            type: 'is-info',
            hasIcon: false,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            confirmText: this.$t('discount.actionLabels.tryAgain'),
            ariaModal: true,
          })
        }
      });
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters(['discount'])
  },
  mounted(){
    if(this.discount){
      this.discountCode = this.discount.code || '';
    }
  }
}
</script>

<style lang="scss">
.section--discount {
  .validate-button {
    height: 100%;
  }
}
</style>